import { motion } from 'framer-motion';
import useResponsive from '../hooks/useResponsive';

const Page = ({ children, className = '', disableTransition = false}) => {
  const { isMobile, isTablet } = useResponsive();

  // Variants para la animación de opacidad (entrada y salida del componente)
  const opacityVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3, ease: 'linear' } },
    exit: { opacity: 0, transition: { duration: 0.3, ease: 'linear' } }
  };

  return (
    <motion.div
      className="h-full w-full"
      variants={disableTransition ? {} : opacityVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div
        className={`h-full ${className}`}
      >
        {children}
      </div>
    </motion.div>
  );
};

export default Page;